import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateLogEntryCache,
  LogEntryCacheEvents,
} from '@monorepo/shared/cacheRegisters/data2/logEntryCacheRegister';
import { MutationConfig, useMutation } from 'react-query';

type UseEdpAiSubmissionDeleteParams = {
  config?: MutationConfig<void, Api.ErrorResponse>;
};

export const useEdpAiSubmissionDelete = (
  params?: UseEdpAiSubmissionDeleteParams,
) =>
  useMutation(Api.deleteEdpAiSubmission, {
    ...params?.config,
    onSuccess: (_, { logId, organizationId, projectId }) => {
      invalidateLogEntryCache(LogEntryCacheEvents.DELETE, {
        logId,
        organizationId,
        projectId,
      });
    },
  });
